module.exports = __webpack_public_path__ + "static/img/detail2.54caed6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/detail2.jpg
// module id = +mAz
// module chunks = 0